import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import {BrowserRouter} from "react-router";
import AuthProvider from "./context/authContext.tsx";
import AuthOTPProvider from "./context/auth/authOtpContext.tsx";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AuthOTPProvider>
        
          <BrowserRouter>
            <App />
          </BrowserRouter>
        
      </AuthOTPProvider> 
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

